<template>
  <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 578 130" width="100" height="50">
    <path fill-rule="evenodd" class="a" d="m637.3 130v-108.6h6.3v108.6z" />
    <path
      class="a"
      d="m746.9 97.7c-2.5 0.7-5.6 1.5-10.3 1.5q0 0-0.1 0 0 0 0 0c-4.7 0-7.8-0.8-10.3-1.5-1.9-0.5-3.5-0.9-5.3-0.9-3.5 0-7.3 1.1-9 1.7q0 0.2 0.1 0.5 0 0 0 0c0 0 1.3 5.4 6.9 10 5.6 4.6 17.5 12.8 17.5 12.8 0 0 13.2-9.4 15.4-11 6.4-5.1 8.3-9.1 8.9-11.1h0.1c0 0 0.2-0.6 0.3-1.2-1.8-0.6-5.5-1.7-8.9-1.7-1.8 0-3.4 0.4-5.3 0.9z"
    />
    <path
      class="a"
      d="m746.9 91.1c-2.5 0.7-5.6 1.5-10.3 1.5q0 0-0.1 0 0 0 0 0c-4.7 0-7.8-0.8-10.3-1.5-1.9-0.4-3.5-0.9-5.3-0.9-3.6 0-7.5 1.2-9.2 1.8v3.2c2.2-0.7 5.8-1.6 9.2-1.6 2.3 0 4.1 0.5 6.1 1 2.4 0.7 5.2 1.4 9.5 1.4 4.4 0 7.1-0.7 9.6-1.4 1.9-0.5 3.8-1 6.1-1 3.4 0 6.9 0.9 9 1.5v-3.2c-1.7-0.5-5.5-1.7-9-1.7-1.9 0-3.4 0.5-5.3 0.9z"
    />
    <path
      class="a"
      d="m761.2 59.6l-15 26q-0.1 0-0.2 0.1c-0.9 0.2-1.8 0.5-2.9 0.7l17.2-29.8h-3l-17.5 30.3q-1.2 0.1-2.8 0.1l17.7-30.4h-3l-17.6 30.4q-1.4-0.1-2.5-0.3l17.4-30.1h-37.3v32c2.2-0.7 5.8-1.6 9.2-1.6 2.3 0 4.1 0.5 6.1 1 2.4 0.7 5.2 1.4 9.5 1.4 4.4 0 7.1-0.7 9.6-1.4 1.9-0.5 3.8-1 6.1-1 3.4 0 6.9 0.9 9 1.5v-18.8l-8.6 15q-0.3 0-0.5 0-1.2 0-2.3 0.1l11.4-19.7zm-35.3 12.3l-0.8 3.8-0.8-3.8-3.9-0.8 3.9-0.9 0.8-3.8 0.8 3.9 3.8 0.8z"
    />
    <path
      class="a"
      d="m1054.7 121c11.5 0 20.8-4.8 26.5-13.1l-5.3-3.6c-4.7 6.6-11.9 10.6-21.2 10.6-15 0-25.9-11.3-25.9-26.5 0-15.2 10.9-26.5 25.9-26.5 9.3 0 16.2 4 20.3 10l5.2-3.7c-5.5-8.2-14.2-12.4-25.5-12.4-18.3 0-33 13.4-33 32.6 0 19.2 14.7 32.6 33 32.6z"
    />
    <path
      class="a"
      d="m993.9 55.9h-1.1l-26.7 64.4h6.7l4.3-10.7h32.5l4.3 10.7h7.2zm-14.4 47.8l11.3-28.3c1.2-3 2.6-7.5 2.6-7.5 0 0 1.2 4.5 2.4 7.5l11.4 28.3h-27.8z"
    />
    <path
      class="a"
      d="m930.7 56.6h-15.6v63.7h15.6c21.6 0 34.8-12.6 34.8-31.9 0-19.3-13.3-31.8-34.8-31.8zm-0.4 57.6h-8.3v-51.5h8.3c19 0 28 10.6 28 25.7 0 15.2-9 25.8-28 25.8z"
    />
    <path class="a" d="m864.1 120.3h40.5v-6h-33.7v-15.9h28.8v-5.9h-28.8v-29.9h32.3v-6h-39.1z" />
    <path
      class="a"
      d="m835.4 55.9h-1.1l-17.6 45.4c-1 2.6-2 6.2-2 6.2 0 0-0.8-3.6-1.9-6.2l-17.3-45.4h-1.1l-21.2 64.4h6.9l13.4-42.5c0.9-2.7 1.8-6.9 1.8-6.9 0 0 1.1 4.2 2.1 6.9l16.8 43.1h1.1l16.7-43.1c1.1-2.7 2.1-6.9 2.1-6.9 0 0 1 4.1 1.8 6.9l13.5 42.5h7.3l-21.3-64.4z"
    />
    <path class="a" d="m201.1 43h18.2l19.1 60.6h1.4l18.9-60.6h18.7l-26.3 77.1h-23.6z" />
    <path
      class="a"
      d="m370.5 42.9h17.4v8.9h1.3c3.4-5.9 10.5-10.8 20.8-10.8 16.9 0 27.6 12.7 27.6 28.6v50.5h-17.3v-46.4c0-9.6-6.8-16.2-15.6-16.2-9.6 0-16.8 7.4-16.8 17.1v45.5h-17.4v-77.2z"
    />
    <path
      class="a"
      d="m449.3 96.9v-38.6-15.4-21.6h17.5v21.6h21.8v15.4h-21.8v38.5c0 5.5 2.2 7.8 7.5 7.8h13.4v15.5h-13.5c-15 0-24.9-6.8-24.9-23.1z"
    />
    <path
      class="a"
      d="m495.1 81.7c0-24.3 17.8-40.7 38.6-40.7 23.5 0 37.8 17.1 37.8 40.1v4.8h-58.4c0.1 13 8.5 21.2 21.2 21.2 8.5 0 16.6-4.4 19.4-12.9l15.9 3.8c-5 16-19.1 24-35.2 24-23.5 0-39.3-16.8-39.3-40.4zm58.8-8.4c-0.9-10.4-9.6-17-20.2-17-10.6 0-19.4 7.8-20.5 17z"
    />
    <path
      class="a"
      d="m100.5 28.7c-4.9-9-12-16.1-21.1-21.2-9.1-5-19.9-7.5-32.1-7.5h-47.3v35.3l29.6 23.5c0.8 0.6 0.8 1.8 0 2.4l-29.5 23.5h-0.1v35.4h47.4c12.1 0 22.9-2.6 32-7.6 9.1-5 16.2-12.1 21.1-21.2 4.9-9 7.4-19.6 7.4-31.3 0-11.7-2.5-22.4-7.4-31.4zm-81.9 60.8l32.1-25.5c2.4-1.9 2.5-5.6 0-7.5l-32.1-25.8v-14h29.1c13.1 0 23.3 4 30.4 11.9 7.1 7.8 10.7 18.4 10.7 31.5 0 13.1-3.6 23.7-10.7 31.5-7.1 8-17.3 12-30.4 12h-29.1z"
    />
    <path
      class="a"
      d="m174.3 43h17.9v77.1h-17.9v-8.1q-11 10.3-23.7 10.3-16 0-26.4-11.6-10.4-11.8-10.4-29.4c0-11.8 3.5-21.2 10.4-28.9q10.4-11.6 25.9-11.6 13.5 0 24.2 11.1v-8.9zm-42.3 38.3q0 11.1 6 18 6.1 7.1 15.3 7.1 9.9 0 16-6.8 6.1-7.1 6.1-17.9c0-7.3-2-13.2-6.1-17.9q-6.1-6.9-15.8-6.9-9.2 0-15.4 7-6.1 7-6.1 17.4z"
    />
    <path
      class="a"
      d="m338.6 43h17.9v77.1h-17.9v-8.1q-11 10.3-23.7 10.3-16 0-26.4-11.6-10.4-11.8-10.4-29.4c0-11.8 3.5-21.2 10.4-28.9q10.4-11.6 25.9-11.6 13.5 0 24.2 11.1v-8.9zm-42.3 38.3q0 11.1 5.9 18 6.1 7.1 15.4 7.1 9.9 0 16-6.8 6.1-7.1 6.1-17.9c0-7.3-2-13.2-6.1-17.9q-6.1-6.9-15.8-6.9-9.2 0-15.4 7-6.1 7-6.1 17.4z"
    />
  </svg>
</template>

<script lang="ts" setup></script>
<style scoped>
.a {
  fill: #0234ab;
}
</style>
